import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import Heading from "../ui/Heading";
import { Link } from "react-router-dom/cjs/react-router-dom";
import DesignDiamondRingImg from '../../../../../Assets/nokaoi-imges/ring-setting.webp'

const DesignDiamondRing = () => {
  const settings = {
    customPaging: function (i) {
      return <a className="dots11">{i + 1}</a>;
    },
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <section className="RingBuilderHome design-diamond-ring-section section-space">
      <Container>
        <Row className="align-items-center">
          
          <Col md={6} xs={12}>
            {/* <div
              className="wistia_responsive_padding"
              style={{ padding: "56.25% 0 0 0", position: "relative" }}
            >
              <div
                className="wistia_responsive_wrapper"
                style={{
                  height: "100%",
                  left: "0",
                  position: "absolute",
                  top: "0",
                  width: "100%",
                }}
              >
                <iframe
                  title="592c8ccf Video"
                  src="https://fast.wistia.net/embed/iframe/1frgc1kbdw?seo=false&videoFoam=true"
                  allow="autoplay; fullscreen"
                  allowtransparency="true"
                  frameborder="0"
                  scrolling="no"
                  className="wistia_embed"
                  name="wistia_embed"
                  msallowfullscreen
                  width="100%"
                  height="100%"
                ></iframe>
              </div>
            </div> */}
            <div className="design_you_own_ring_box">
            <Image src={DesignDiamondRingImg} className="img-fluid" alt="design-diamond-ring" />
            </div>
          </Col>
          <Col md={6} xs={12}>
            <div className="textBox">
              <Heading className="text-start p-0">
                <span>Create your Own Diamond Ring</span>
                {/* <h2>Diamond Ring</h2> */}
                <p>
                Select a setting and choose a diamond to create your own diamond engagement ring.
                </p>
                <p className="mt-3">
<strong>Need help? </strong> Visit our Hawaiian jewelry store
                </p>
                <div className="content mt-4">
                  <Link
                    to="/engagement-rings"
                    className="btn outline-base-btn small mr-md-3 mr-0"
                  >
                    Start with a setting
                  </Link>
                  <br></br>
                  <Link to="/diamonds" className="btn outline-base-btn small">
                    Start with a diamond{" "}
                  </Link>
                </div>
              </Heading>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default DesignDiamondRing;
